var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n    We have the ability to produce unique products that fit your specific needs and desired project results.\n  ")]),_c('carousel',{attrs:{"item":"architectural-elements","images":_vm.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }